/*
 * Copyright (C) 2022 SHC Holdings LLC.  All Rights Reserved.
 */
export var ENV_MIN_PATIENT_BUSINESS_RULE = parseInt(process.env.REACT_APP_MIN_PATIENT_BUSINESS_RULE || '11', 10);
export var ENV_LEGEND_COLORS = (process.env.REACT_APP_LEGEND_COLORS || '#ccc,#ffff00,#ffd226,#ffa143,#f27151,#d9434c,#b71933,#8b0000').split(',');
export var ENV_STATE_BORDER_COLOR = process.env.REACT_APP_STATE_BORDER_COLOR || '#A9A9A9';
